import React, { FC } from 'react';

import { Order } from '../../types/order';
import StateDropdownModal from './StateDropdownModal';

interface Props {
    order: Order | null;
}

const ProgressMessages: FC<Props> = ({ order, ...props }) => {
    const activeStatuses = !!order ? order.status.short.filter(s => s.state !== 'incomplete') : [];
    return (
        <div className="jd-order-messages">
            {order !== null &&
                order.status.short.map((status, index) => {
                    return (
                        <div key={index} className="jd-order-messages__step">
                            {status.description && index + 1 === activeStatuses.length && (
                                <div
                                    className="jd-order-messages__step-message"
                                    dangerouslySetInnerHTML={{ __html: status.description }}
                                />
                            )}
                            <StateDropdownModal status={status} order={order} />
                        </div>
                    );
                })}
        </div>
    );
};

export default ProgressMessages;
